export const cameras = [
    {
        name: 'Front Hazard Avoidance Camera',
        link: 'FHAZ'
    },
    {
        name: 'Rear Hazard Avoidance Camera',
        link: 'RHAZ'
    },
    {
        name: 'Mast Camera',
        link: 'MAST'
    },
    {
        name: 'Chemistry and Camera Complex',
        link: 'CHEMCAM'
    },
    {
        name: 'Mars Hand Lens Imager',
        link: 'MAHLI'
    },
    {
        name: 'Mars Descent Imager',
        link: 'MARDI'
    },
    {
        name: 'Navigation Camera',
        link: 'NAVCAM'
    },
    {
        name: 'Panoramic Camera',
        link: 'PANCAM'
    },
    {
        name: 'Miniature Thermal Emission Spectrometer',
        link: 'MINITES'
    },
   
]